module.exports = __webpack_public_path__ + "media/images/icons/add-document-28e34c85fad8a0b870b970d1168c8f85.svg";